import React from "react";
import ReactDOM from "react-dom";
import App from "App";
import { SnackbarProvider } from "notistack";

import "i18nextInit";

ReactDOM.render(
  <SnackbarProvider>
    <App />
  </SnackbarProvider>,
  document.getElementById("root")
);
